import { render, staticRenderFns } from "./OrderNote.vue?vue&type=template&id=49a8b9ae&"
import script from "./OrderNote.vue?vue&type=script&lang=js&"
export * from "./OrderNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports